module.exports = __webpack_public_path__ + "static/media/question-mark.1761ff9c.svg";